// Static value that can be analyzed by Next.js at build time
// Production: 3600 seconds (1 hour), Development: 30 seconds
export const DEFAULT_REVALIDATE = 3600;
